module.exports = __webpack_public_path__ + "media/entities/1014-41bb13df.png";